<template>
  <v-container>
    <!-- Sección: Sobre nosotros -->
    <v-col cols="12" md="10" lg="8" class="mx-auto">
      <h2 class="header-title">
        Quiénes Somos
      </h2>
    </v-col>

    <v-card elevation="3" class="rounded-xl">
      <v-tabs v-model="tab" color="deep-purple-accent-4" align-tabs="center" grow class="tab-titles">
        <v-tab :value="1"></v-tab>
        <v-tab :value="2">Misión</v-tab>
        <v-tab :value="3">Visión</v-tab>
        <v-tab :value="4">Historia</v-tab>
      </v-tabs>

      <v-window v-model="tab" class="pa-6">
        <v-window-item :value="1">
          <p class="text-body-1 text--secondary">
            "Generar Servicios integrales de protección de salud para nuestros clientes
            con innovación y creatividad; con la mejor relación calidad, costo-beneficio, a través de la excelencia,
            efectividad y desarrollo de nuestros colaboradores; buscando hacer socios de negocios a nuestros principales
            proveedores, creando valor para los accionistas y promoviendo una cultura preventiva en la sociedad en
            general"
          </p>
        </v-window-item>

        <v-window-item :value="2">
          <p class="text-body-1 text--secondary mb-4">
            Ser la mejor opción del mercado en servicios de acceso y protección a la salud.
          </p>
          <ul class="no-bullets pl-4">
            <li><v-icon color="success" small class="mr-2">mdi-check</v-icon>Trabajo en equipo</li>
            <li><v-icon color="success" small class="mr-2">mdi-check</v-icon>Cultura emprendedora</li>
            <li><v-icon color="success" small class="mr-2">mdi-check</v-icon>Confiabilidad</li>
            <li><v-icon color="success" small class="mr-2">mdi-check</v-icon>Compromiso</li>
          </ul>
        </v-window-item>

        <v-window-item :value="3">
          <v-timeline dense>
            <v-timeline-item color="deep-purple" fill-dot>
              <div class="timeline-year">2006</div>
              <div>
                Inicio de operaciones con el servicio de <strong>CONSULTA EXTERNA</strong> con médicos especialistas. Se
                establece la
                primera RED de
                prestadores MEDICOVER®.
              </div>
            </v-timeline-item>

            <v-timeline-item color="deep-purple" fill-dot>
              <div class="timeline-year">2008</div>
              <div>
                Se ve la necesidad de iniciar una Alianza Estratégica con proveedores hospitalarios a efecto de que se
                brinde a los usuarios los servicios de atención médica de <strong>URGENCIA</strong> por la pérdida de la
                salud a causa de una ENFERMEDAD o ACCIDENTE y cuya resolución se de en un lapso menor a las 24 horas.
              </div>
            </v-timeline-item>

            <v-timeline-item color="deep-purple" fill-dot>
              <div class="timeline-year">2010</div>
              <div>
                Se incorpora la cobertura <strong>DENTAL</strong> mediante una red de especialistas en ortodoncia,
                endodoncia,
                odontopediatría,
                cirugía ortognática y maxilofacial.
              </div>
            </v-timeline-item>

            <v-timeline-item color="deep-purple" fill-dot>
              <div class="timeline-year">2011</div>
              <div>
                Lanzamiento de servicios <strong>VISUALES</strong> con lentes y exámenes oftalmológicos a precios
                preferentes.
              </div>
            </v-timeline-item>

            <v-timeline-item color="deep-purple" fill-dot>
              <div class="timeline-year">Actualidad</div>
              <div>
                Se continúa innovando con servicios como <strong>"Farmacia a tu casa"</strong>, descuentos en estudios
                de laboratorio,
                imagenología y
                hospitalización. <br /><small>Cabe señalar que durante éstos años de servicio, se han blindado nuestras
                  membresías MEDICOVER® con
                  descuentos en Estudios de Laboratorio e Imagenología, y tarifas preferentes en caso de que nuestros
                  usuarios
                  necesiten hospitalizarse en la RED de prestadores de éstos servicios. Para nosotros es un orgullo ser
                  los
                  primeros en brindar a nuestros usuarios, servicios innovadores en materia del cuidado de la salud,
                  siendo la
                  empresa líder en éste segmento utilizando el concepto de membresías de servicios médicos.</small>
              </div>
            </v-timeline-item>
          </v-timeline>
        </v-window-item>

        <v-window-item :value="4">

          <p class="text-body-1 text--secondary text-justify">
          </p>
        </v-window-item>
      </v-window>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'SliderComponent',
  data() {
    return {
      tab: 1,
    }
  }
}
</script>

<style scoped>
.timeline-year {
  font-weight: bold;
  font-size: 1.1rem;
  margin-bottom: 4px;
  color: #5e35b1;
  /* deep-purple */
}

.no-bullets {
  list-style: none;
  padding-left: 0;
  /* opcional si no quieres sangría */
}
</style>
